const pendingLoads = new Map();

export function loadClassicScript(src, { id, optional = false } = {}) {
  if (pendingLoads.has(src)) return pendingLoads.get(src);

  const promise = new Promise((resolve, reject) => {
    const existing = id ? document.getElementById(id) : document.querySelector(`script[src="${src}"]`);
    if (existing?.dataset.loaded === "true") {
      resolve();
      return;
    }

    const script = existing || document.createElement("script");
    if (id) script.id = id;
    script.src = src;
    script.async = false;

    const finish = () => {
      script.dataset.loaded = "true";
      resolve();
    };
    const fail = () => {
      const error = new Error(`Unable to load ${src}`);
      if (optional) {
        console.warn(error.message);
        resolve();
      } else {
        reject(error);
      }
    };

    script.addEventListener("load", finish, { once: true });
    script.addEventListener("error", fail, { once: true });
    if (!existing) document.head.appendChild(script);
  });

  pendingLoads.set(src, promise);
  return promise;
}

export async function loadPortalRuntime(role) {
  if (!window.signalR) {
    await loadClassicScript("/js/microsoft/signalr/dist/browser/signalr.js", {
      id: "stemeit-signalr",
      optional: true
    });
  }

  if (role === "admin") {
    if (!window.Chart) {
      await loadClassicScript("https://cdn.jsdelivr.net/npm/chart.js", {
        id: "stemeit-chartjs"
      });
    }
    if (!window.Tesseract) {
      await loadClassicScript("https://cdn.jsdelivr.net/npm/tesseract.js@4/dist/tesseract.min.js", {
        id: "stemeit-tesseract",
        optional: true
      });
    }
  }

  if (role === "client") {
    // Queue both non-async classic scripts together. This preserves the Razor
    // page's original execution order and prevents the inline script's timers
    // from firing while the larger client runtime is still being downloaded.
    const inlineLayout = loadClassicScript("/legacy/client-layout-inline.js", {
      id: "stemeit-client-layout-inline"
    });
    const clientRuntime = loadClassicScript("/legacy/client_site.js", {
      id: "stemeit-client-runtime"
    });
    await Promise.all([inlineLayout, clientRuntime]);
  } else if (role === "supplier") {
    await loadClassicScript("/legacy/supplier_site.js", { id: "stemeit-supplier-runtime" });
  } else {
    await loadClassicScript("/legacy/admin_site.js", { id: "stemeit-admin-runtime" });
  }

  await loadClassicScript("/legacy/utils.js", { id: "stemeit-shared-runtime" });
}
